import { render, staticRenderFns } from "./appmain.vue?vue&type=template&id=c08b0a46&scoped=true"
import script from "./appmain.vue?vue&type=script&lang=js"
export * from "./appmain.vue?vue&type=script&lang=js"
import style0 from "./appmain.vue?vue&type=style&index=0&id=c08b0a46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08b0a46",
  null
  
)

export default component.exports